import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Texts } from '../../core/entities/texts.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TextsService {
    readonly BASE: any = PETICIONES.texts;

    constructor(private http: HttpClient) { }

    /**
    * @description
    * Obtiene todos los texts
    */
    public findAll(): Observable<any> {
        return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene un text por su code
    */
    public findByCode(id: string): Observable<any> {
        let codetexts: string = (id !== undefined && id !== null ? id + "" : "");
        return this.http.get(this.BASE.findByCode + "/" + codetexts).pipe(delay(DELAY));
    }

    /**
    * @description
    * Guarda un text en la base de datos
    */
    public postText(texts: Texts): Observable<any> {
        const json = JSON.stringify(texts);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postTexts, json, {headers: headers}).pipe(delay(DELAY));
    }

    /**
    * @description
    * Borra un texts en la base de datos
    */
     public deleteText(texts: Texts): Observable<any> {
        let codetexts: string = (texts.code !== undefined && texts.code !== null ? texts.code + "" : "");
        return this.http.get(this.BASE.deleteTexts + "/" + codetexts).pipe(delay(DELAY));
    }
}